import { Alert, Box, Snackbar, Typography, useMediaQuery } from '@mui/material'
import React, { useState } from 'react'
import { blue, fontTitle, yellow } from '../MainPage/styles'
import { Motion } from './Motion';
import { logAnalytics, phoneClick } from '../firebase_init';

const YellowBox = ({ title, text, href, target = '_self', onClick = () => { } }) => {
    const smallRes = useMediaQuery(`(max-width:700px)`);
    const smallFont = useMediaQuery(`(max-width:1000px)`);

    return <Motion scale={1.02} style={{ flex: 1, display: 'flex' }}>
        <Box component={'a'} href={href} target={target} sx={{
            bgcolor: yellow, borderRadius: '20px', flex: 1, display: 'flex', flexDirection: 'column', textDecoration: 'none',
            alignItems: 'center', alignContent: 'center', justifyContent: 'center', minHeight: smallRes ? '120px' : '106px'
        }} onClick={onClick}>
            <Typography sx={{ ...fontTitle, ...(smallFont && { fontSize: '28px', lineHeight: '38px' }) }}>
                {title}
            </Typography>
            <Typography sx={{}}>
                {text}
            </Typography>
        </Box>
    </Motion>;
}

export default function Calculation() {
    const smallRes = useMediaQuery(`(max-width:700px)`);
    const [copied, setCopied] = useState(false);

    return (
        <>
            <Snackbar
                open={copied}
                autoHideDuration={1500}
                onClose={() => setCopied(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Alert severity="info" sx={{
                    bgcolor: yellow,
                    color: blue,
                    '& .MuiAlert-icon': {
                        color: blue,
                    },
                }}>
                    Adresa zkopírována
                </Alert>
            </Snackbar>
            <Box sx={{ py: '50px', textAlign: 'center' }}>
                <Typography sx={{ ...fontTitle, pb: '50px' }}>
                    Kalkulace ceny předem
                </Typography>
                <Typography sx={{}}>
                    Zašlete nám na <b>e-mail</b> nebo <b>WhatsApp</b> fotku vaší sedačky, křesla či koberce včetně detailu případných fleků. Obratem vám zpracujeme přesnou a nezávaznou cenovou nabídku, ať předem přesně víte, s čím počítat.
                </Typography>

            </Box>
            <Box sx={{ display: 'flex', flexDirection: smallRes ? 'column' : 'row', pb: '50px', gap: '10px', width: '100%', }}>
                <YellowBox title="Telefon" text="797 996 873" href={'tel:+420797996873'} onClick={() => {
                    logAnalytics("phone_click_fire");
                    phoneClick();
                }} />
                <YellowBox title="Email" text="info@cistidoma.cz" href={'mailto:info@cistidoma.cz'} onClick={async () => {
                    await navigator.clipboard.writeText('info@cistidoma.cz');
                    setCopied(true);
                    logAnalytics("email_click");
                }} />
                <YellowBox title="WhatsApp" text="797 996 873" href={"https://wa.me/420123456789"} target='_blank' onClick={() => {
                    logAnalytics("whatsapp_click");
                }} />
            </Box>
        </>
    )
}
